import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { BehaviorSubject, Observable, Subject, tap } from "rxjs";
import { SnackBarConfig } from "../../constants/snackbar.constants";
import { MatSnackBar } from "@angular/material/snack-bar";
import { WishListAttributes } from "@models/wishlist.model";

@Injectable({
    providedIn: "root",
})
export class WishlistService {
    public wishlistCountSubject = new BehaviorSubject(0);
    public wishlistCount$: Observable<number> = this.wishlistCountSubject.asObservable();
    public wishlistIDS: { productIDs: number[] } = { productIDs: [] };
    public wishlistSignal = new Subject<number>();
    public wishlistSignal$ = this.wishlistSignal.asObservable();

    constructor(
        private http: HttpClient,
        private snackBar: MatSnackBar,
    ) {}

    public getWishlistedProducts(): Observable<{ productIDs: number[] }> {
        return this.http.get<{ productIDs: number[] }>(
            `${environment.apiUrlBasePath}/wishlist/getWishListedProductIds`,
        );
    }

    public getWishListItems(
        skip: number = 0,
        pageSize: number = 10,
    ): Observable<{ rows: WishListAttributes[]; count: number }> {
        return this.http.get<{ rows: WishListAttributes[]; count: number }>(
            `${environment.apiUrlBasePath}/wishlist/getWishListItems?pageSize=${pageSize}&skip=${skip}`,
        );
    }

    public addToWishList(productIDs: number[]): Observable<string> {
        return this.http.post<string>(`${environment.apiUrlBasePath}/wishlist/add`, productIDs).pipe(
            tap((response) => {
                if (!response) return;

                const next = new Set(this.wishlistIDS.productIDs);
                productIDs.forEach((id) => next.add(id));

                this.wishlistIDS.productIDs = Array.from(next);
                this.wishlistCountSubject.next(this.wishlistIDS.productIDs.length);

                this.snackBar.open(response, SnackBarConfig.Actions.CLOSE, {
                    duration: SnackBarConfig.Duration.MEDIUM,
                });
            }),
        );
    }

    public loadMyWishlistItems(): void {
        this.getWishlistedProducts().subscribe((response) => {
            this.wishlistIDS = response;
            this.wishlistCountSubject.next(this.wishlistIDS.productIDs.length);
        });
    }

    public get getAllwishlistIDs(): { productIDs: number[] } {
        return this.wishlistIDS;
    }

    public deleteFromMyWishlist(productID: number): Observable<string> {
        return this.http.delete<string>(`${environment.apiUrlBasePath}/wishlist/delete/${productID}`).pipe(
            tap((response) => {
                if (response) {
                    this.wishlistIDS.productIDs = this.wishlistIDS.productIDs.filter((id: number) => id !== productID);
                    this.wishlistCountSubject.next(this.wishlistIDS.productIDs.length);
                }
            }),
        );
    }

    public resetWishlist(): void {
        this.wishlistIDS.productIDs = [];
        this.wishlistCountSubject.next(this.wishlistIDS.productIDs.length);
    }
}
